<template>
  <c-card>
    <template slot="title">
      {{ name }}
    </template>

    <div slot="header">
      <el-button
        :loading="approveStatus === $config.status.LOADING"
        round
        type="success"
        @click="approve"
      >
        Freischalten
      </el-button>

      <el-button
        round
        type="danger"
        @click="remove"
      >
        Löschen
      </el-button>

      <c-button-link
        round
        :to="{
          name: `${type}-detail`,
          params: { id }
        }"
      >
        Details
      </c-button-link>
    </div>
  </c-card>
</template>

<script>
import CButtonLink from '@/components/CButtonLink'
import CCard from '@/components/CCard'

import api from '@/api'

export default {
  name: 'CRegistrationCard',

  components: {
    CButtonLink,
    CCard
  },

  props: {
    id: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true,
      validator: value => value === 'coach' || value === 'coachee'
    }
  },

  data () {
    return {
      approveStatus: this.$config.status.IDLE,
      removeStatus: this.$config.status.IDLE
    }
  },

  methods: {
    approve () {
      if (!window.confirm('Möchten Sie dieses Konto wirklich freischalten?')) {
        return
      }

      this.approveStatus = this.$config.status.LOADING

      api[this.type]
        .approve(this.id)
        .then(() => {
          this.approveStatus = this.$config.status.SUCCESS
          this.$emit('change')
        })
        .catch(() => {
          this.$notify.error({
            title: 'Fehler',
            message: 'Das Konto konnte leider nicht freigeschaltet werden.'
          })

          this.approveStatus = this.$config.status.ERROR
        })
    },
    remove () {
      if (!window.confirm('Möchten Sie dieses Konto wirklich löschen?')) {
        return
      }

      this.removeStatus = this.$config.status.LOADING

      api[this.type]
        .deleteAccount(this.id)
        .then(() => {
          this.removeStatus = this.$config.status.SUCCESS
          this.$emit('change')
        })
        .catch(() => {
          this.$notify.error({
            title: 'Fehler',
            message: 'Das Konto konnte leider nicht gelöscht werden.'
          })

          this.removeStatus = this.$config.status.ERROR
        })
    }
  }
}
</script>
